module.exports = __webpack_public_path__ + "static/media/vivi-pensando-direita.1e2c6995.svg";